import { TableCell } from '@e2n/ui/v2';
import { cn } from 'cn';
import { useTranslation } from 'react-i18next';
import type { AbgleichZeile } from '../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';
import {
  ABGLEICH_SPALTEN,
  ABGLEICH_ZEILE_CLASS,
  type Quelle,
} from './abgleichKonstanten';

const FEHLT_CLASS = 'bg-brand-red-200/25';
const NUR_IN_QUELLE_CLASS = 'bg-accent-green-100/25';
const ABWEICHUNG_CLASS = 'bg-accent-orange-100/25';
const KEIN_WERT = '–';

export function AbgleichZellen({
  zeile,
  quelle,
}: {
  zeile: AbgleichZeile;
  quelle: Quelle;
}) {
  const { t } = useTranslation();
  const { e2n, datev, abweichendeFelder } = zeile;
  const daten = quelle === 'e2n' ? e2n : datev;

  if (!daten) {
    return (
      <TableCell
        colSpan={ABGLEICH_SPALTEN.length}
        text={t('domain.datev.abgleich.fehlt')}
        className={cn(ABGLEICH_ZEILE_CLASS, FEHLT_CLASS)}
      />
    );
  }

  const nurInDieserQuelle = !e2n || !datev;

  return ABGLEICH_SPALTEN.map(({ feld }) => (
    <TableCell
      key={feld}
      text={daten[feld] ?? KEIN_WERT}
      className={cn(
        ABGLEICH_ZEILE_CLASS,
        nurInDieserQuelle && NUR_IN_QUELLE_CLASS,
        abweichendeFelder.includes(feld) && ABWEICHUNG_CLASS,
      )}
    />
  ));
}
